import { GALLERY_CONSTS } from 'pro-gallery-lib';
import {
  StyleParamType,
  createStylesParam,
  wixColorParam,
} from '@wix/tpa-settings';

import { EMediaLayout } from 'settings/constants';

export const MediaLayoutMap = {
  [EMediaLayout.Grid]: GALLERY_CONSTS.layoutParams_structure_galleryLayout.GRID,
  [EMediaLayout.Collage]:
    GALLERY_CONSTS.layoutParams_structure_galleryLayout.COLLAGE,
  [EMediaLayout.Masonry]:
    GALLERY_CONSTS.layoutParams_structure_galleryLayout.MASONRY,
};

export const actionsColorParam = createStylesParam('media-actions-color', {
  type: StyleParamType.Color,
  getDefaultValue: wixColorParam('color-5'),
});

export const bgColorParam = createStylesParam('media-background-color', {
  type: StyleParamType.Color,
  getDefaultValue: wixColorParam('color-1'),
});
